import { ArrowRight, MessageCircle, MapPin, Mail, Phone } from "lucide-react";

export const FinalCTA = () => {
  return (
    <section 
      id="booking"
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="final-cta"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      {/* Decorative corner accents */}
      <div className="absolute top-12 left-12 w-20 h-20 border-l border-t border-[#D4AF37]/15 hidden lg:block" />
      <div className="absolute bottom-12 right-12 w-20 h-20 border-r border-b border-[#D4AF37]/15 hidden lg:block" />
      
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 lg:px-12 text-center">
        {/* Header */}
        <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
          Take the Next Step
        </span>
        
        <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-white mt-4 md:mt-6 mb-6 md:mb-8 leading-tight">
          Secure Your Property Investment
          <span className="block text-[#D4AF37] italic mt-2">with Trusted Legal Counsel</span>
        </h2>
        
        <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mb-8 md:mb-10" />
        
        {/* Content */}
        <div className="space-y-5 md:space-y-6 max-w-3xl mx-auto mb-10 md:mb-12">
          <p className="text-white/60 text-sm md:text-base lg:text-lg leading-[1.9]">
            Whether you are purchasing property in Nigeria for the first time or expanding an 
            existing investment portfolio, proper legal due diligence is essential.
          </p>
          <p className="text-white/60 text-sm md:text-base lg:text-lg leading-[1.9]">
            4 ACES Attorneys provides the legal clarity and protection serious investors need 
            when navigating Nigeria's real estate market.
          </p>
        </div>
        
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center mb-12 md:mb-16">
          <a
            href="mailto:privateclients@4acesattorneys.com?subject=Consultation%20Request"
            className="group inline-flex items-center justify-center gap-2 md:gap-3 bg-[#D4AF37] text-[#0A0A0B] px-8 md:px-10 py-4 md:py-5 text-sm font-semibold tracking-wide hover:bg-[#C5A028] transition-all duration-300"
            data-testid="final-cta-book"
          >
            Book a Private Consultation
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="https://wa.me/2348032143826?text=Hello%204ACES%20Attorneys%2C%20I%20saw%20your%20website%20and%20would%20like%20to%20discuss%20a%20property%20transaction%20in%20Nigeria."
            className="group inline-flex items-center justify-center gap-2 md:gap-3 bg-[#25D366] text-white px-8 md:px-10 py-4 md:py-5 text-sm font-semibold tracking-wide hover:bg-[#20BD5A] transition-all duration-300"
            data-testid="final-cta-whatsapp"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp Enquiry
          </a>
        </div>
        
        {/* Contact Info */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8 pt-8 md:pt-10 border-t border-[#D4AF37]/20">
          <div className="flex items-center justify-center gap-2 md:gap-3">
            <Mail className="w-4 h-4 md:w-5 md:h-5 text-[#D4AF37]" />
            <a 
              href="mailto:privateclients@4acesattorneys.com" 
              className="text-white/60 hover:text-[#D4AF37] transition-colors text-xs md:text-sm"
            >
              privateclients@4acesattorneys.com
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 md:gap-3">
            <Phone className="w-4 h-4 md:w-5 md:h-5 text-[#D4AF37]" />
            <a 
              href="https://wa.me/2348032143826?text=Hello%204ACES%20Attorneys%2C%20I%20saw%20your%20website%20and%20would%20like%20to%20discuss%20a%20property%20transaction%20in%20Nigeria."
              className="text-white/60 hover:text-[#D4AF37] transition-colors text-xs md:text-sm"
            >
              +234 803 214 3826
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 md:gap-3">
            <MapPin className="w-4 h-4 md:w-5 md:h-5 text-[#D4AF37]" />
            <span className="text-white/60 text-xs md:text-sm">
              Guzape District, FCT Abuja
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
